import { allRoutes } from "generated/routes"
import { PageTabs } from "components/navigation/PageTabs/PageTabs"
import { useTranslation } from "react-i18next"

export const EditCustomerNavigation = ({ customerId }) => {
  const { t } = useTranslation()

  const tabs1 = [
    {
      title: t("global.basic_information", "Basic information"),
      path: allRoutes.SystemadminCustomersEditCustomer(customerId)
    },
    {
      title: t("global.company", "Company"),
      path: allRoutes.SystemadminCustomersEditCompanies(customerId)
    },
    {
      title: t("global.users", "Users"),
      path: allRoutes.SystemadminCustomersEditUsers(customerId)
    }
  ]

  return <PageTabs tabs={tabs1} />
}
